export default "__VITE_ASSET__x75je2K8__"